import api from "../../../../../features/auth/axiosConfig";
import { errorHandling } from "src/shared/utils/errorHandling";
import { getLedgerByCustomer, getOrder, patchCustomer, putCancelOrder } from "src/shared/services/servicesv2";

export const getOrdersApi = async (orderid: string, history: any) => {
  const orderDetails = `${orderid}?${history}`
  try {
    const res = await getOrder(orderDetails);
    return res;
  } catch (err) {
    console.error("getOrdersApi Error:", err);
    throw err;
  }
};

export const getLedgerByCustomerIdApi = async (customerid: string) => {
  try {
    const res = await getLedgerByCustomer(customerid);
    return res;
  } catch (err) {
    console.error("getLedgerByCustomerIdApi Error:", err);
    throw err;
  }
};

// ✅ FIXED: Accept the array directly
export const updateCustomerEmailApi = async (customerId: string, emails: { email: string; isPrimary: boolean }[]) => {
  try {
    // Pass the emails array directly - the API expects this format
    const res = await patchCustomer(customerId, emails);
    return res;
  } catch (err) {
    errorHandling(err);
    throw err;
  }
};

export const cancelOrderApi = async (orderId: string | undefined, adjustType: string, paymentMethod?: string, cancelDate?: string, cancelTime?: string) => {
  const payload: any = {
    orderStatus: "Cancelled",
    cancelDate: cancelDate,
    cancelTime: cancelTime,
  };

  if (paymentMethod !== "Buy on Credit") {
    payload.adjustType = adjustType;
  }

  try {
    const res = await putCancelOrder(orderId, payload);
    return res;
  } catch (err) {
    console.error("cancelOrderApi Error:", err);
    throw err;
  }
};

export const updateOrderStatusApi = async (orderId: string | undefined, orderStatus: string) => {
  const order = { orderStatus: orderStatus, statusChange: true };

  try {
    const res = await api.patch(`/app/pos/v2/order/${orderId}`, order);
    return res;
  } catch (err) {
    console.error("updateOrderStatusApi Error:", err);
    throw err;
  }
};
